import { Divider, Typography, Box, TextField, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAuthorize } from '~features/authentication';

import { useStyles } from './style';
import { SidepanelContainer, SidePanel } from '../../../../../components';
import { commaTimeStrings } from '../../../../../shared/datetime';
import { isObject } from '../../../../../shared/utility';

interface SidePanelCardProps {
	getTicketData?: object;
	status?: string;
	setStatus?(...args: unknown[]): unknown;
	setDialogStatus?(...args: unknown[]): unknown;
	statusOfTicket?: unknown[];
}

const SidePanelCard = (props: SidePanelCardProps) => {
	const { getTicketData, status, setStatus, setDialogStatus, statusOfTicket } = props;
	const { t } = useTranslation();
	const { authorizeForOrganisation } = useAuthorize();

	const classes = useStyles();

	const updateOption = (name) => {
		setStatus(name);
		setDialogStatus(true);
	};

	const handleStatusChange = (event) => {
		const newValue = event.target.value;
		updateOption(newValue);
	};

	const closed = status === 'closed';

	// TOP-1863: the ticket is managed by the organisation owning the item and by the organisation
	// providing the service, so authorize both - mirroring the rule already used by the ticket list.
	const canChangeStatus =
		authorizeForOrganisation(
			getTicketData?.itemInstanceReference?.hubReference?.organisationReference?.id
		) ||
		(isObject(getTicketData?.serviceReference) &&
			authorizeForOrganisation(getTicketData.serviceReference.id));

	return (
		<SidepanelContainer className={classes.sideCard} sticky={true}>
			<SidePanel>
				<Box display='flex' flexDirection='column'>
					<Typography variant='h4'>
						{`${t('ui.ticket.labelCapitalize')} ${getTicketData.id}`}
					</Typography>
					<Typography variant='body2'>
						{`${t('views.ticketsDetails.lastUpdated')}: ${commaTimeStrings(getTicketData.dateModified)}`}
					</Typography>
				</Box>
				<Box pb={2} pt={2}>
					<Typography gutterBottom={true} variant='h6'>{`${t('ui.label.status')}:`}</Typography>
					<TextField
						SelectProps={{ value: status || '' }}
						disabled={getTicketData.status === 'closed' || closed || !canChangeStatus}
						fullWidth={true}
						onChange={handleStatusChange}
						select
						size='small'
						variant='outlined'
					>
						{statusOfTicket.map((tStatus) => (
							<MenuItem key={tStatus.label} value={tStatus.label}>
								{tStatus.name}
							</MenuItem>
						))}
					</TextField>
				</Box>
				<Divider />
				<Box pb={1} pt={1}>
					<Typography variant='h6'>{`${t('views.ticketsDetails.itemDefect')}:`}</Typography>
					<Typography variant='body2'>{getTicketData.defectReference.title}</Typography>
				</Box>
				<Divider />
				<Box pb={1} pt={1}>
					<Typography>{`${t('ui.label.serviceProvider')}:`}</Typography>
					<Typography variant='body2'>
						{isObject(getTicketData.serviceReference) ? getTicketData.serviceReference.name : '-'}
					</Typography>
				</Box>
			</SidePanel>
		</SidepanelContainer>
	);
};

export default SidePanelCard;
